const Cang= {
    namespaced:true,
    state:{
        weather:'',
        project:{},    // 项目信息
        buildTree:[]   // 楼宇树状结构
    },
    mutations:{
        setWeather(state,data){
            console.log(data);
            state.weather = data
        },
        getProject(state, project){
            state.project = project
        },
        getBuildTree(state, tree){
            state.buildTree = tree
        }
    },
    
    getters:{

    },
    actions:{

    },
}
export default Cang